export const DEMODATALIMITING = [
    { name: "invoice", modulePath: 'https://sales-demo.notchcx.io/invoices/' },
    { name: "quotation", modulePath: 'https://sales-demo.notchcx.io/quotations/' },
    { name: "subscription", modulePath: 'https://sales-demo.notchcx.io/subscriptions/' },
    { name: "deals", modulePath: 'https://api-demo.notchcx.io/salesservice/newDeal' },
    { name: "salesOrders", modulePath: 'https://sales-demo.notchcx.io/salesservice/newSalesOrder' },
    { name: "lead", modulePath: 'https://sales-demo.notchcx.io/leads' },
    { name: "company", modulePath: 'https://sales-demo.notchcx.io/companies/' },
    { name: "contact", modulePath: 'https://sales-demo.notchcx.io/contacts/' },
    { name: "tasks", modulePath: 'https://api-demo.notchcx.io/notch_analytics/addTask' },


    // { name: "userInvitation", modulePath: 'https://api-demo.notchcx.io/signup/inviteUser' },
    // { name: "salesPersons", modulePath: 'https://sales-demo.notchcx.io/invoices/' },
    // { name: "teams", modulePath: 'https://sales-demo.notchcx.io/invoices/' },

]

// [
// "targets",
// "activities",
// "Emails",
// "CreditManagement",
// "userInvitation",
// ]


// bankAccount: 1
// currency: 1
// filter: 1
// leadExemption: 1
// leadSource: 0
// leadWorkFlow: 0
// mailTemplate: 1
// orgLeadSource: 2
// orgLeadWorkFlow: 0
// organizationFitness: 1
// payment: 1
// reportRegistry: 1
// salesStats: 1
// schedule: 1
// status: "DATA_PRESENT"
// template: 1
// tickets: 1
// transaction: 6